
const copyObj = <T>(value: T): T => {
  return JSON.parse(JSON.stringify(value));
};

export default copyObj;
